import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import TileButton from './components/TileButton.jsx';
import { InteractionContext } from '../../contexts';

const ActionItem = () => {
  const { values, handleChange } = useContext(InteractionContext);

  return (
    <TileButton
      buttonText={values.answers[0]}
      buttonIndex={0}
      onChangeButtonText={handleChange}
    />
  );
};

export default ActionItem;

ActionItem.propTypes = {
  type: PropTypes.string,
  option: PropTypes.string,
};
